import { useUser } from "@/hooks/use-user";
import { useIsClient } from "@/hooks/use-role";
import { Redirect } from "wouter";

interface RequireClientProps {
  children: React.ReactNode;
}

export function RequireClient({ children }: RequireClientProps) {
  const { user } = useUser();
  const isClient = useIsClient();

  if (!user || !isClient) {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
} 